import type { WeeklyMissionPayload } from './api';

export const MISSION_ACTIVITY_EVENT = 'xbb:mission-activity-changed';

export function missionPayloadFrom(value: unknown): WeeklyMissionPayload | null {
  if (!value || typeof value !== 'object') return null;
  const data = value as Record<string, unknown>;
  if (Array.isArray(data.groups) && data.config && typeof data.total === 'number') {
    return value as WeeklyMissionPayload;
  }
  if (data.mission && data.mission !== value) return missionPayloadFrom(data.mission);
  return null;
}

/** Only successful record mutations publish; GET refreshes never feed back into this event. */
export function notifyMissionMutation(method?: string, url?: string, response?: unknown): void {
  if (!method || !['post', 'put', 'patch', 'delete'].includes(method.toLowerCase()) || !url) return;
  const path = url.replace(/^https?:\/\/[^/]+/, '').split('?')[0];
  const relevant = /^\/api\/diaries(?:\/|$)/.test(path)
    || /^\/api\/records(?:\/|$)/.test(path)
    || /^\/api\/health(?:\/|$)/.test(path)
    || path === '/api/nutrition/water'
    || /^\/api\/nutrition\/meals(?:\/|$)/.test(path)
    || /^\/api\/fitness\/exercise\/sessions(?:\/|$)/.test(path)
    || /^\/api\/pathway\/(?:daily-tasks|weekly-tasks|quiz|verification|subscriptions)(?:\/|$)/.test(path)
    || /^\/api\/life-goals(?:\/|$)/.test(path)
    || path === '/api/exam/submit'
    || /^\/api\/gamification\/weekly-mission(?:\/|$)/.test(path);
  if (relevant && typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(MISSION_ACTIVITY_EVENT, {
      detail: { mission: missionPayloadFrom(response) },
    }));
  }
}
